import type { VueError } from '@sofa/lib-eum'
import type { Plugin } from 'vue'
import { sendError } from '@sofa/lib-eum'

type PluginEum = Plugin

// Plugin eum permettant de remonter des métriques à Instana
const eumPlugin: PluginEum = (appInstance) => {
  appInstance.config.errorHandler = function (err, vm, info) {
    // Permet de remonter les erreurs à Instana
    sendError({ err, vm, info } as VueError)
    throw err
  }
}

export default eumPlugin
